module.exports = __webpack_public_path__ + "static/media/arrow_down_white6e607115.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/arrow_down_white.svg
// module id = 1521
// module chunks = 0